var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('favorites-state-provider',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var favoritesCount = ref.favoritesCount;
return [_c('span',{class:{
            'basket-count': true,
            'basket-count--big': favoritesCount > 9,
            'basket-count--very-big': favoritesCount > 99,
        }},[_vm._v(_vm._s(favoritesCount))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }